export { default } from "./RelatedProducts.jsx";
